module.exports = "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\n\nvoid main(void) {\n  float gridThickness = 0.05;\n  vec3 gridColor = vec3(0.00, 0.59, 0.53); // #009688\n\n  // Edge\n  vec2 eThickness = vec2(gridThickness, gridThickness) / 2.0;\n\n  vec2 ef = fract(vUv);\n  ef = min(ef, 1.0 - ef);\n\n  vec2 eDelta = fwidth(ef);\n  ef = smoothstep(ef - eDelta, ef + eDelta, eThickness);\n\n  float opacity = clamp(ef.x + ef.y, 0.0, 1.0);\n  if(opacity < 0.5) discard;\n\n  gl_FragColor = vec4(gridColor, 0.5);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/glslify-loader!./src/shaders/chunk.frag
 ** module id = 767
 ** module chunks = 0
 **/